import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as LocalStorageUtils from "_core/utils/localstorage";

import './AppContainer.scss';

import * as Constants from "_core/configs/Constants";

const AppContainer = (props) => {
    const { tUser } = useSelector((store) => store.transaction);
    const [serviceType, setServiceType ] = useState(LocalStorageUtils.GetItem(Constants.LOCALSTORAGE_KEYS.serviceType));

    useEffect(() => {
        if (tUser) 
        {
            setServiceType(tUser.service_type);

            console.log("コンテナでリセット");
            console.log(tUser.service_type);
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.serviceType, tUser.service_type);
        }
    }, [tUser]);

    return (
    <div className={"app-container "  + (Constants.SERVICE_TYPE_LABELS[serviceType])}>
        {props.children}
    </div>
    )
};

export default AppContainer;
